// Detects a pasted TrustBox snippet so the tile dispatcher can route it to TrustpilotEmbed
// (which shields Trustpilot's injected iframe from React) instead of the generic CustomHtml.
export function isTrustpilotWidgetHtml(html: string | undefined | null): boolean {
  return html?.includes('trustpilot-widget') ?? false;
}
